module.exports = __webpack_public_path__ + "img/Polygon-2.474ae856.svg";